import React, { useEffect, useRef, useState } from "react";
import { GridLoader } from "../../../../rcsgrid/createGridTools";
import { handleTableAccounts } from "../../../../Tools/Requests";
import { createGrid, createRecordSource } from "../../../../rcsgrid/rcsgrid";
import { Prefixes } from "../../../../Tools/ProjectX";
import clsx from "clsx";
import styles from "../dialogStyles.module.css";
import { HTMLGridPanelElement, PermissionFlags } from "../../../../../ComponentInterface";

interface AccountsTableForTabsProps {
  props: {
    ObjType?: string;
    Params?: { ObjType?: string };
    Module?: Prefixes;
    SectionID?: string;
    selectedRecordID?: string;
    rights?: PermissionFlags;
    setAccSelectedRecordID?: (id: string) => void;
    disabled?: boolean;
  };
}
/**
 * Возвращает контент для вкладки аккаунтов
 *
 * Поля компонента:
 *    1. [mainGrid, setMainGrid] - состояние текущей таблицы
 *    2. gridPanel - ссылка на контейнер с таблицей
 *    3. accBox - ссылка на контейнер с компонентом аккаунтов
 *
 * @param {Object} [props]
 * @param {string} [props.Module] модуль для вкладки аккаунтов
 * @param {string} [props.ObjType] тип объекта
 * @param {string} [props.Params] дополнительные данные о вкладке
 * @param {string} [props.SectionID] id секции
 * @param {string} [props.selectedRecordID] выбранная запись из основной таблицы
 * @param {string} [props.setAccSelectedRecordID] колбэк на смену id в таблице аккаунтов
 * @returns Возвращает контент для вкладки аккаунтов с таблицей
 */
export default function AccountsTableForTabs({ props }: AccountsTableForTabsProps) {
  const {
    Module: module,
    ObjType: objType,
    Params: params,
    SectionID: sectionId,
    selectedRecordID,
    setAccSelectedRecordID,
  } = props;
  const [mainGrid, setMainGrid] = useState<{ grid: createGrid; source: createRecordSource }>();
  const gridPanel = useRef<HTMLGridPanelElement>(null);
  const accBox = useRef<HTMLDivElement>(null);

  /**
   * Загрузка таблицы аккаунтов
   */
  const loadGrid = async () => {
    const res = await GridLoader(gridPanel.current, props, {
      sub: true,
      GroupID: selectedRecordID,
      ObjType: objType || params?.ObjType,
      setSelectedRecord: setAccSelectedRecordID,
    });
    setMainGrid(res);
  };
  useEffect(() => {
    loadGrid();
  }, []);

  /**
   * Обновление таблицы аккаунтов в зависимости от выбранной записи основной таблицы
   */
  const refreshMainGrid = async () => {
    if (!mainGrid?.source || !module) return;
    mainGrid.source.onHandleRequest = handleTableAccounts(
      module,
      objType || params?.ObjType,
      selectedRecordID,
      sectionId,
    );

    await mainGrid.source.first();
    await mainGrid.source.refresh();
    await mainGrid.grid.setSource(mainGrid.source);
    setAccSelectedRecordID?.(mainGrid.source.getFieldTextSync("ID"));
    await mainGrid.grid.updateGridSize();
  };
  useEffect(() => {
    refreshMainGrid();
  }, [selectedRecordID]);

  return (
    <div ref={accBox} id="accBox" className={clsx(styles.fullDialogSpaceContainer)}>
      <div
        id={`rcgrid_panel`}
        ref={gridPanel}
        style={{
          height: "100%",
          width: "100%",
          position: "relative",
        }}
      ></div>
    </div>
  );
}
